import {Beyable} from '@beyable/sdk';

const beyable = new Beyable({token: "aaaaaaaaa2ba8518775d9400e97d43eeeb3519c4a"});

export {beyable};
